import * as React from "react";
import { OwnerProvider } from "@/context/OwnerContext";
import OwnerCollection from "./owner-collection";
import OwnerEditView from "./owner-edit-view";
import OwnerNft from "./owner-nft";
import { OwnerData } from "@/types";
import OwnerReferral from "./owner-referral";

export default function OwnerContainer({
  ownerData,
}: {
  ownerData: OwnerData | null;
}) {
  return (
    <div className="flex flex-col min-h-screen bg-black w-full overflow-x-hidden">
      <OwnerEditView ownerDatas={ownerData} />
      <OwnerCollection collectionData={ownerData?.collections || []} />
      <OwnerNft itemsData={ownerData?.items || []} />
      <OwnerReferral />
    </div>
  );
}
